import React from 'react';
import { useTranslation } from 'react-i18next';

const Resume = () => {
    const { t } = useTranslation();
    
    const handleDownloadCV = () => {
        const link = document.createElement('a');
        link.href = '/docs/CV_FNI.pdf';
        link.download = 'CV_Furkan_Necati_Inan.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="page-content">
            <div className="resume-header">
                <h1>{t('resume.title')}<span className="accent">.</span></h1>
                <button className="download-btn" onClick={handleDownloadCV}>
                    {t('resume.download')}
                </button>
            </div>

            <div className="resume-content">
                <section className="resume-section">
                    <h2>{t('resume.contact.title')}</h2>
                    <div className="contact-info">
                        <p><strong>{t('resume.contact.email')}:</strong> furkaninan37@gmail.com</p>
                        <p><strong>{t('resume.contact.linkedin')}:</strong> linkedin.com/in/furkan-necati-inan</p>
                        <p><strong>{t('resume.contact.github')}:</strong> @furkannecatiinan</p>
                        <p><strong>{t('resume.contact.location')}:</strong> {t('resume.contact.ankara')}</p>
                    </div>
                </section>

                <section className="resume-section">
                    <h2>{t('resume.education.title')}</h2>
                    <div className="resume-item">
                        <div className="resume-title">
                            <h3>{t('resume.education.degree')}</h3>
                            <span className="resume-date">{t('resume.education.duration')}</span>
                        </div>
                        <div className="resume-subtitle">{t('resume.education.university')}</div>
                        <div className="resume-location">{t('resume.education.location')}</div>
                        <ul className="resume-details">
                            <li><strong>{t('resume.education.relevantCoursework')}:</strong> {t('resume.education.coursework')}</li>
                            <li><strong>{t('resume.education.languages')}:</strong> {t('resume.education.turkish')}, {t('resume.education.english')}</li>
                        </ul>
                    </div>
                </section>

                <section className="resume-section">
                    <h2>{t('resume.experience.title')}</h2>

                    <div className="resume-item">
                        <div className="resume-title">
                            <h3>{t('resume.experience.juniorDataScientist')}</h3>
                            <span className="resume-date">{t('resume.experience.duration')}</span>
                        </div>
                        <div className="resume-subtitle">{t('resume.experience.inventAnalytics')}</div>
                        <div className="resume-location">{t('resume.experience.location')}</div>
                        <ul className="resume-details">
                            {t('resume.experience.responsibilities', { returnObjects: true }).map((responsibility, index) => (
                                <li key={index}>{responsibility}</li>
                            ))}
                        </ul>
                        <div className="resume-skills">
                            <span className="skill-tag">Agentic AI</span>
                            <span className="skill-tag">LLMs</span>
                            <span className="skill-tag">RAG</span>
                            <span className="skill-tag">Automation</span>
                        </div>
                    </div>

                    <div className="resume-item">
                        <div className="resume-title">
                            <h3>{t('resume.experience.aiResearchIntern')}</h3>
                            <span className="resume-date">{t('resume.experience.researchDuration')}</span>
                        </div>
                        <div className="resume-subtitle">{t('resume.experience.biologicalDataLab')}</div>
                        <div className="resume-location">{t('resume.experience.location')}</div>
                        <ul className="resume-details">
                            {t('resume.experience.researchResponsibilities', { returnObjects: true }).map((responsibility, index) => (
                                <li key={index}>{responsibility}</li>
                            ))}
                        </ul>
                        <div className="resume-skills">
                            <span className="skill-tag">Bioinformatics</span>
                            <span className="skill-tag">CNN</span>
                            <span className="skill-tag">Transformers</span>
                            <span className="skill-tag">PyTorch</span>
                        </div>
                    </div>

                    <div className="resume-item">
                        <div className="resume-title">
                            <h3>{t('resume.experience.baykarIntern')}</h3>
                            <span className="resume-date">{t('resume.experience.baykarDuration')}</span>
                        </div>
                        <div className="resume-subtitle">{t('resume.experience.baykar')}</div>
                        <div className="resume-location">{t('resume.experience.baykarLocation')}</div>
                        <ul className="resume-details">
                            {t('resume.experience.baykarResponsibilities', { returnObjects: true }).map((responsibility, index) => (
                                <li key={index}>{responsibility}</li>
                            ))}
                        </ul>
                        <div className="resume-skills">
                            <span className="skill-tag">Computer Vision</span>
                            <span className="skill-tag">Object Detection</span>
                            <span className="skill-tag">Aerial Imagery</span>
                        </div>
                    </div>
                </section>

                <section className="resume-section">
                    <h2>{t('resume.skills.title')}</h2>
                    <div className="skills-grid">
                        <div className="skill-category">
                            <h4>{t('resume.skills.programming')}</h4>
                            <p>{t('resume.skills.programmingList')}</p>
                        </div>
                        <div className="skill-category">
                            <h4>{t('resume.skills.aiMl')}</h4>
                            <p>{t('resume.skills.aiMlList')}</p>
                        </div>
                        <div className="skill-category">
                            <h4>{t('resume.skills.webDev')}</h4>
                            <p>{t('resume.skills.webDevList')}</p>
                        </div>
                        <div className="skill-category">
                            <h4>{t('resume.skills.devops')}</h4>
                            <p>{t('resume.skills.devopsList')}</p>
                        </div>
                    </div>
                </section>

                <section className="resume-section">
                    <h2>{t('resume.projects.title')}</h2>
                    
                    <div className="resume-item">
                        <div className="resume-title">
                            <h3>{t('resume.projects.muchem.title')}</h3>
                        </div>
                        <div className="resume-subtitle">{t('resume.projects.projectParticipant')}</div>
                        <ul className="resume-details">
                            {t('resume.projects.muchem.description', { returnObjects: true }).map((desc, index) => (
                                <li key={index}>{desc}</li>
                            ))}
                        </ul>
                        <div className="resume-skills">
                            <span className="skill-tag">PyTorch</span>
                            <span className="skill-tag">Deep Learning</span>
                            <span className="skill-tag">Multimodal</span>
                            <span className="skill-tag">Drug Discovery</span>
                        </div>
                    </div>

                    <div className="resume-item">
                        <div className="resume-title">
                            <h3>{t('resume.projects.deepscreen2.title')}</h3>
                        </div>
                        <div className="resume-subtitle">{t('resume.projects.projectParticipant')}</div>
                        <ul className="resume-details">
                            {t('resume.projects.deepscreen2.description', { returnObjects: true }).map((desc, index) => (
                                <li key={index}>{desc}</li>
                            ))}
                        </ul>
                        <div className="resume-skills">
                            <span className="skill-tag">CNN</span>
                            <span className="skill-tag">XAI</span>
                            <span className="skill-tag">SHAP</span>
                            <span className="skill-tag">Bioinformatics</span>
                        </div>
                    </div>

                    <div className="resume-item">
                        <div className="resume-title">
                            <h3>{t('resume.projects.mooc.title')}</h3>
                        </div>
                        <div className="resume-subtitle">{t('resume.projects.projectParticipant')}</div>
                        <ul className="resume-details">
                            {t('resume.projects.mooc.description', { returnObjects: true }).map((desc, index) => (
                                <li key={index}>{desc}</li>
                            ))}
                        </ul>
                        <div className="resume-skills">
                            <span className="skill-tag">LSTM</span>
                            <span className="skill-tag">XGBoost</span>
                            <span className="skill-tag">LightGBM</span>
                            <span className="skill-tag">XAI</span>
                        </div>
                    </div>

                    <div className="resume-item">
                        <div className="resume-title">
                            <h3>{t('resume.projects.tec.title')}</h3>
                        </div>
                        <div className="resume-subtitle">{t('resume.projects.projectParticipant')}</div>
                        <ul className="resume-details">
                            {t('resume.projects.tec.description', { returnObjects: true }).map((desc, index) => (
                                <li key={index}>{desc}</li>
                            ))}
                        </ul>
                        <div className="resume-skills">
                            <span className="skill-tag">Python</span>
                            <span className="skill-tag">GNSS</span>
                            <span className="skill-tag">Data Visualization</span>
                        </div>
                    </div>

                    <div className="resume-item">
                        <div className="resume-title">
                            <h3>{t('resume.projects.webInfra.title')}</h3>
                        </div>
                        <div className="resume-subtitle">{t('resume.projects.projectParticipant')}</div>
                        <ul className="resume-details">
                            {t('resume.projects.webInfra.description', { returnObjects: true }).map((desc, index) => (
                                <li key={index}>{desc}</li>
                            ))}
                        </ul>
                        <div className="resume-skills">
                            <span className="skill-tag">React</span>
                            <span className="skill-tag">Spring Boot</span>
                            <span className="skill-tag">Docker</span>
                            <span className="skill-tag">Nginx</span>
                            <span className="skill-tag">MySQL</span>
                            <span className="skill-tag">CI/CD</span>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Resume; 